function showReviewPopup() {
  let formAttempts = 0;
  
  if (window.showReviewPopupInterval) {
    clearInterval(window.showReviewPopupInterval);
  }

  window.showReviewPopupInterval = setInterval(() => {
    formAttempts++;
    if (formAttempts > 50) { // Max 10 seconds
      clearInterval(window.showReviewPopupInterval);
      return;
    }

    const judgemeReviews = document.getElementById('judgeme_product_reviews');
    
    if (judgemeReviews) {
      const link = judgemeReviews.querySelector('.jdgm-write-rev-link');

      if (link && window.jdgm && window.jdgm._WriteReviewModal) {
        clearInterval(window.showReviewPopupInterval);
        
        // Timeout to ensure Judge.me event listeners are fully attached
        setTimeout(() => {
          link.click();
        }, 100);
      }
    }
  }, 200);
}

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', showReviewPopup);
} else {
  showReviewPopup();
}
